import {
    UPDATE_TALE,MAP_IN_ADD_TALE,UPDATE_MAP_DATA,UPDATE_STATISTICS_DATA,UPDATE_AREAS_DATA
} from "constants/ActionTypes";
import { UPDATE_MOST_FAIRY_UPLOAD_DATA } from "../constants/ActionTypes";
//import { update_statistics_data } from "../actions/Tale";

const INIT_STATE = {
    taleId: -1,
    isUpdate:false,
    selectedAreaAndCity:{},
    mapData:[],
    areasData:{},
    statisticsData:{},
    mostFairyTaleUploadUserListData:[]

    //authUser: JSON.parse(localStorage.getItem('user')),
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UPDATE_TALE: {
               return {
                   ...state,
                   taleId: action.payload.taleId,
                   isUpdate: action.payload.isUpdate
               }
           }
           case MAP_IN_ADD_TALE: {
               return {
                   ...state,
                   selectedAreaAndCity: action.payload,
               }
           }
           case UPDATE_MAP_DATA: {
               return {
                   ...state,
                   mapData: action.payload.mapData,
               }
           }
           case UPDATE_AREAS_DATA: {
               return {
                   ...state,
                   areasData: action.payload.areasData,
               }
           }
           case UPDATE_STATISTICS_DATA: {
               return {
                   ...state,
                   statisticsData: action.payload.statisticsData,
               }
           }
           case UPDATE_MOST_FAIRY_UPLOAD_DATA: {
            return {
                ...state,
                mostFairyTaleUploadUserListData: action.payload.mostFairyTaleUploadUserListData,
            }
        }
        default:
            return state;
    }
}
